var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import * as classnames from "classnames";
var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getOuterTabClasses = function () {
            var _a = _this.props, selected = _a.selected, disabled = _a.disabled;
            return classnames("wds-tab__tab", { "wds-tab__tab--selected": selected }, { "wds-tab__tab--disabled": disabled });
        };
        _this.handleClick = function (event) {
            var _a = _this.props, onChange = _a.onChange, value = _a.value, id = _a.id;
            if (!!onChange) {
                onChange(event, value, id);
            }
        };
        return _this;
    }
    Tab.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, value = _a.value, selected = _a.selected, id = _a.id, innerRef = _a.innerRef;
        var component = this.props.component ? this.props.component : React.createElement("button", null);
        var NewComponent = React.cloneElement(component, {
            disabled: disabled,
            value: value,
            role: "tab",
            tabIndex: disabled ? -1 : 0,
            "aria-selected": selected,
            className: "wds-tab__tab-btn",
            onClick: this.handleClick,
            id: id,
            ref: innerRef,
            children: this.props.children
        });
        return React.createElement("li", { className: this.getOuterTabClasses() }, NewComponent);
    };
    Tab.defaultProps = {
        children: "",
        disabled: false,
        id: null,
        innerRef: null,
        onChange: null,
        selected: false,
        value: 0,
        component: null
    };
    return Tab;
}(React.Component));
export default Tab;
//# sourceMappingURL=Tab.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Tabs/Tab.js
// module id = 1814
// module chunks = 17